<div *ngIf="cmsComponent?.data$ | async as componentData">
  <div class="puff-collection-holder row no-gutters component-holder" [ngClass]="styleClasses">
    <ng-container *ngFor="let puffUid of puffUids">
      <ng-container
        [styleClassesOverride]="styleClasses"
        [cxComponentWrapper]="{
          flexType: 'PuffComponent',
          typeCode: 'PuffComponent',
          uid: puffUid
        }"
      ></ng-container>
    </ng-container>
  </div>
  <py-puff-collection-pagination
    [puffComponentsArray]="componentData.components?.split(' ')"
    [maxShown]="componentData?.maxShown || 0"
    [showPagination]="componentData?.pagingEnabled == 'true'"
    (setPuffUids)="onSetPuffUids($event)"
  ></py-puff-collection-pagination>
</div>
